import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { MODAL_DATA_HOOKS } from './dataHooks';

export interface ModalDriver extends BaseUniDriver {
  childExists(predicate: string): Promise<boolean>;
  isOpen(): Promise<boolean>;
}

export const modalDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): ModalDriver => {
  const childExists = async (predicate: string) => {
    const element = await queryDocumentOrElement(predicate);

    return element.exists();
  };

  const queryDocumentOrElement = async (query: string) => {
    const element = base.$(query);
    if (await element.exists()) {
      return element;
    }
    return body.$(query);
  };

  const getContentElement = async () => {
    const contentSelector = `[data-hook="${MODAL_DATA_HOOKS.CONTENT}"]`;
    return queryDocumentOrElement(contentSelector);
  };

  return {
    ...baseUniDriverFactory(base),
    childExists,
    isOpen: async () => {
      let isOpen;

      try {
        const content = await getContentElement();
        isOpen = await content.exists();
      } catch (e) {
        isOpen = false;
      }

      return isOpen;
    },
  };
};
